import React from 'react';
import { Row, Col, Select, Input, DatePicker, Button } from 'antd';
import { MinusCircleFilled } from '@ant-design/icons';

const { Option } = Select;

export default function AdvancedSearchFilters({
  filter,
  index,
  onChange,
  onRemove,
  fields,
}) {

  const field = fields?.find(f => f.value === filter.field);
  const fieldType = field?.type;

  const operatorsByType = {
    string: [
      { label: 'Contains', value: 'CO' },
      { label: 'Is', value: 'EQ' },
      { label: 'Starts with', value: 'BW' },
      { label: 'Ends with', value: 'EW' },
    ],
    date: [
      { label: 'Is', value: 'EQ' },
      { label: 'Is before', value: 'LT' },
      { label: 'Is after', value: 'GT' },
      { label: 'Is between', value: 'BE' },
      { label: 'Is not', value: 'NEQ' },
    ]
  };

  const handleUpdate = (key, value) => {
    onChange(index, { ...filter, [key]: value });
  };

  return (
    <Row gutter={8} style={{ marginBottom: 8 }} align="middle">
      <Col>
        <Select
          placeholder="Field"
          value={filter.field}
          onChange={(val) => handleUpdate('field', val)}
          style={{ width: 140 }}
        >
          {fields?.map(f => (
            <Option key={f.value} value={f.value}>{f.label}</Option>
          ))}
        </Select>
      </Col>
      <Col>
        <Select
          placeholder="Operator"
          value={filter.operator}
          onChange={(val) => handleUpdate('operator', val)}
          style={{ width: 140 }}
        >
          {(operatorsByType[fieldType] || []).map(op => (
            <Option key={op.value} value={op.value}>{op.label}</Option>
          ))}
        </Select>
      </Col>
      <Col>
        {filter.operator === 'BE' ? (
          <>
            <DatePicker
              value={filter.value?.[0]}
              onChange={(val) =>
                handleUpdate('value', [val, filter.value?.[1] || null])
              }
            />
            <span style={{ margin: '0 8px' }}>AND</span>
            <DatePicker
              value={filter.value?.[1]}
              onChange={(val) =>
                handleUpdate('value', [filter.value?.[0] || null, val])
              }
            />
          </>
        ) : fieldType === 'date' ? (
          <DatePicker
            value={filter.value}
            onChange={(val) => handleUpdate('value', val)}
          />
        ) : (
          <Input
            value={filter.value}
            onChange={(e) => handleUpdate('value', e.target.value)}
            placeholder="Value"
          />
        )}
      </Col>
      <Col>
        <Button icon={<MinusCircleFilled />} type='link' onClick={() => onRemove(index)} />
      </Col>
    </Row>
  );
}